function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "noun_Heart_1742986",
  transform: "translate(-10.985 -967.397)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_254",
  "data-name": "Path 254",
  d: "M17.105,967.4a5.975,5.975,0,0,0-4.338,1.861,6.527,6.527,0,0,0,0,8.963l9.073,9.515a.885.885,0,0,0,1.28,0l9.082-9.506a6.524,6.524,0,0,0,0-8.963,5.977,5.977,0,0,0-8.677,0l-1.041,1.078-1.041-1.087a5.975,5.975,0,0,0-4.339-1.861Zm0,1.732a4.239,4.239,0,0,1,3.067,1.354l1.676,1.759a.884.884,0,0,0,1.28,0l1.667-1.75a4.146,4.146,0,0,1,6.125,0,4.763,4.763,0,0,1,0,6.522q-4.218,4.414-8.438,8.824L14.047,977a4.763,4.763,0,0,1,0-6.522A4.219,4.219,0,0,1,17.105,969.129Z",
  fill: "#25a4b4"
}));

var SvgIconHeart = function SvgIconHeart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20.613,
    viewBox: "0 0 23 20.613",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconHeart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-heart.3e0c674d.svg";
export { ForwardRef as ReactComponent };